function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from "react";
import Button from "react-bootstrap/Button";
// const Asana = require("asana");
import { GET_ASANA_OAUTH_TOKEN_QUERY, ADD_ACCESS_TOKEN_MUTATION, GET_ZOHO_ACCESS_TOKEN_MUTATION, GET_INTEGRATION_DETAILS_QUERY, IMPORT_INTEGRATION_PROJECT_MUTATION, IMPORT_INTEGRATION_PROJECT_AND_TASK_MUTATION, DISCONNECT_INTEGRATION_DETAILS_MUTATION } from "./query";
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import Loader from "./../Loader/Loader";
import { toast } from "react-toastify";
import { UserContext, FilterContext } from "../index";
import "./Integrations.css";
import Form from "react-bootstrap/Form";
var ZOHO_REDIRECT_URI = "http://localhost:3000/integrations";
var Integrations = function Integrations(props) {
  var _props$history2;
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    integrationSettings = _React$useState2[0],
    setIntegrationSettings = _React$useState2[1];
  var _useQuery = useQuery(GET_INTEGRATION_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    integrationData = _useQuery.data,
    integrationError = _useQuery.error,
    integrationLoading = _useQuery.loading;
  var _useLazyQuery = useLazyQuery(GET_ASANA_OAUTH_TOKEN_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getAsanaToken = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    data = _useLazyQuery2$.data,
    error = _useLazyQuery2$.error,
    loading = _useLazyQuery2$.loading;
  var _useMutation = useMutation(GET_ZOHO_ACCESS_TOKEN_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    getZohoAccessToken = _useMutation2[0],
    zohoTokenLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(ADD_ACCESS_TOKEN_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    addAccessToken = _useMutation4[0],
    adding = _useMutation4[1].loading;
  var _useMutation5 = useMutation(IMPORT_INTEGRATION_PROJECT_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    importIntegrationProject = _useMutation6[0],
    importProjectLoading = _useMutation6[1].loading;
  var _useMutation7 = useMutation(IMPORT_INTEGRATION_PROJECT_AND_TASK_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    importIntegrationProjectAndTask = _useMutation8[0],
    importProjectAndTaskLoading = _useMutation8[1].loading;
  var _useMutation9 = useMutation(DISCONNECT_INTEGRATION_DETAILS_MUTATION),
    _useMutation10 = _slicedToArray(_useMutation9, 2),
    disconnectIntegrationDetails = _useMutation10[0],
    disconnectIntegrationLoading = _useMutation10[1].loading;
  React.useEffect(function () {
    var _data$getAsanaOAuthTo;
    if (data !== null && data !== void 0 && (_data$getAsanaOAuthTo = data.getAsanaOAuthToken) !== null && _data$getAsanaOAuthTo !== void 0 && _data$getAsanaOAuthTo.url) {
      var _data$getAsanaOAuthTo2;
      setLocalStorageForName("asana");
      window.open(data === null || data === void 0 ? void 0 : (_data$getAsanaOAuthTo2 = data.getAsanaOAuthToken) === null || _data$getAsanaOAuthTo2 === void 0 ? void 0 : _data$getAsanaOAuthTo2.url, "_self");
    }
  }, [data]);
  React.useEffect(function () {
    var _props$history, _props$history$locati;
    var code = props === null || props === void 0 ? void 0 : (_props$history = props.history) === null || _props$history === void 0 ? void 0 : (_props$history$locati = _props$history.location) === null || _props$history$locati === void 0 ? void 0 : _props$history$locati.search;
    var selectedApiName = getLocalStorageData("apiName");
    if (code) {
      if (selectedApiName == "zoho") {
        var zohoCodeTemp = code.split("=")[1];
        zohoCodeTemp = zohoCodeTemp.substring(0, zohoCodeTemp.length - 9);
        setLocalStorageData(zohoCodeTemp);
        props.history.replace({
          search: ""
        });
      }
      if (selectedApiName == "asana") {
        var codeTemp = decodeURIComponent(code.substring(code.indexOf("=") + 1));
        setLocalStorageData(codeTemp);
        props.history.replace({
          search: ""
        });
      }
    } else {
      if (selectedApiName == "asana") {
        var _code = getLocalStorageData("code");
        if (_code) {
          removeLocalStorage("apiName");
          removeLocalStorage("code");
          authorizeAsanaToken(_code);
        }
      } else if (selectedApiName == "zoho") {
        var _code2 = getLocalStorageData("code");
        if (_code2) {
          removeLocalStorage("apiName");
          removeLocalStorage("code");
          authorizeZohoToken(_code2);
        }
      }
    }
  }, [props === null || props === void 0 ? void 0 : (_props$history2 = props.history) === null || _props$history2 === void 0 ? void 0 : _props$history2.location]);
  var authorizeAsanaToken = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(code) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return addAccessToken({
              variables: {
                organisationId: organisationId,
                code: code
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_INTEGRATION_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 3:
            response = _context.sent;
            if (!response || !response.data || response.data.addAccessToken == null) {
              toast.error("Error occured, try again");
            } else {
              toast.success("Asana connected succesfully");
            }
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            toast.error("Error occured, try again");
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [addAccessToken, adding]);
  var authorizeZohoToken = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(zohoCode) {
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            variables = {
              code: zohoCode,
              organisationId: organisationId
            };
            _context2.prev = 1;
            _context2.next = 4;
            return getZohoAccessToken({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_INTEGRATION_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 4:
            response = _context2.sent;
            if (!response || !response.data || response.data.getZohoAccessToken == null) {
              toast.error("Error occured, try again");
            } else {
              toast.success("Zoho connected succesfully");
            }
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            toast.error("Error occured, try again");
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 8]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [getZohoAccessToken, zohoTokenLoading]);
  var authorizeProjectsAndTasks = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(apiName) {
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            variables = {
              organisationId: organisationId,
              apiName: apiName
            };
            _context3.prev = 1;
            _context3.next = 4;
            return importIntegrationProjectAndTask({
              variables: variables
            });
          case 4:
            response = _context3.sent;
            if (!response || !response.data || response.data.importIntegrationProjectAndTask == null) {
              toast.error("Error occured, try again");
            } else {
              toast.success("Project and task imported successsfuly!");
            }
            _context3.next = 11;
            break;
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            toast.error("Error occured, try again");
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 8]]);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), [importIntegrationProjectAndTask, importProjectAndTaskLoading]);
  var authorizeProjects = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(apiName) {
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            variables = {
              organisationId: organisationId,
              apiName: apiName
            };
            _context4.prev = 1;
            _context4.next = 4;
            return importIntegrationProject({
              variables: variables
            });
          case 4:
            response = _context4.sent;
            if (!response || !response.data || response.data.importIntegrationProject == null) {
              toast.error("Error occured, try again");
            } else {
              toast.success("Project imported successsfuly!");
            }
            _context4.next = 11;
            break;
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](1);
            toast.error("Error occured, try again");
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 8]]);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }(), [importIntegrationProject, importProjectLoading]);
  function connectZohoOAuth() {
    setLocalStorageForName("zoho");
    window.open("https://accounts.zoho.in/oauth/v2/auth?scope=ZohoProjects.portals.ALL,ZohoProjects.projects.ALL,ZohoProjects.activities.ALL,ZohoProjects.feeds.ALL,ZohoProjects.status.ALL,ZohoProjects.milestones.ALL,ZohoProjects.tasklists.ALL,ZohoProjects.tasks.ALL,ZohoProjects.timesheets.ALL,ZohoProjects.bugs.ALL,ZohoProjects.events.ALL,ZohoProjects.forums.ALL,ZohoProjects.clients.ALL,ZohoProjects.users.ALL,ZohoProjects.documents.READ,ZohoProjects.search.READ,ZohoProjects.tags.ALL,ZohoProjects.calendar.ALL,ZohoProjects.integrations.ALL,ZohoProjects.projectgroups.ALL,ZohoProjects.entity_properties.ALL,ZohoPC.files.ALL,WorkDrive.workspace.ALL,WorkDrive.files.ALL,WorkDrive.team.ALL&client_id=1000.PEP1V4FSQ9JJNS3OUVNFKJAM2Y62YE&response_type=code&redirect_uri=".concat(ZOHO_REDIRECT_URI, "&access_type=offline&prompt=consent"), "_self");
  }
  function checkProjectManagementIntegration(apiName) {
    if (apiName == "Asana") {
      if (integrationSettings && integrationSettings.asana && integrationSettings.asana.projectData) {
        return true;
      }
      return false;
    } else if (apiName == "Zoho") {
      if (integrationSettings && integrationSettings.zoho && integrationSettings.zoho.projectData) {
        return true;
      }
      return false;
    } else if (apiName == "Basecamp") {
      if (integrationSettings && integrationSettings.basecamp && integrationSettings.basecamp.projectData) {
        return true;
      }
      return false;
    } else if (apiName == "Monday.com") {
      if (integrationSettings && integrationSettings.monDay && integrationSettings.monDay.projectData) {
        return true;
      }
      return false;
    } else if (apiName == "Teamwork") {
      if (integrationSettings && integrationSettings.teamWork && integrationSettings.teamWork.projectData) {
        return true;
      }
      return false;
    }
  }
  function changeProjectManagementIntegration(apiName, e) {
    if (apiName == "Asana") {
      setIntegrationSettings({
        asana: {
          projectData: e.target.checked
        }
      });
    } else if (apiName == "Zoho") {
      setIntegrationSettings({
        zoho: {
          projectData: e.target.checked
        }
      });
    } else if (apiName == "Basecamp") {
      setIntegrationSettings({
        basecamp: {
          projectData: e.target.checked
        }
      });
    } else if (apiName == "Monday.com") {
      setIntegrationSettings({
        monDay: {
          projectData: e.target.checked
        }
      });
    } else if (apiName == "Teamwork") {
      setIntegrationSettings({
        teamWork: {
          projectData: e.target.checked
        }
      });
    }
  }
  function checkProjectManagementAndTaskIntegration(apiName) {
    if (apiName == "Asana") {
      if (integrationSettings && integrationSettings.asana && integrationSettings.asana.projectTaskData) {
        return true;
      }
      return false;
    } else if (apiName == "Zoho") {
      if (integrationSettings && integrationSettings.zoho && integrationSettings.zoho.projectTaskData) {
        return true;
      }
      return false;
    } else if (apiName == "Basecamp") {
      if (integrationSettings && integrationSettings.basecamp && integrationSettings.basecamp.projectTaskData) {
        return true;
      }
      return false;
    } else if (apiName == "Monday.com") {
      if (integrationSettings && integrationSettings.monDay && integrationSettings.monDay.projectTaskData) {
        return true;
      }
      return false;
    } else if (apiName == "Teamwork") {
      if (integrationSettings && integrationSettings.teamWork && integrationSettings.teamWork.projectTaskData) {
        return true;
      }
      return false;
    }
  }
  function changeProjectManagementAndTaskIntegration(apiName, e) {
    if (apiName == "Asana") {
      setIntegrationSettings({
        asana: {
          projectTaskData: e.target.checked
        }
      });
    } else if (apiName == "Zoho") {
      setIntegrationSettings({
        zoho: {
          projectTaskData: e.target.checked
        }
      });
    } else if (apiName == "Basecamp") {
      setIntegrationSettings({
        basecamp: {
          projectTaskData: e.target.checked
        }
      });
    } else if (apiName == "Monday.com") {
      setIntegrationSettings({
        monDay: {
          projectTaskData: e.target.checked
        }
      });
    } else if (apiName == "Teamwork") {
      setIntegrationSettings({
        teamWork: {
          projectTaskData: e.target.checked
        }
      });
    }
  }
  function displaySaveButton(apiName) {
    if (apiName == "Asana") {
      if (integrationSettings && integrationSettings.asana && integrationSettings.asana.projectData == true || integrationSettings && integrationSettings.asana && integrationSettings.asana.projectTaskData == true) {
        return true;
      }
      return false;
    } else if (apiName == "Zoho") {
      if (integrationSettings && integrationSettings.zoho && integrationSettings.zoho.projectData == true || integrationSettings && integrationSettings.zoho && integrationSettings.zoho.projectTaskData == true) {
        return true;
      }
      return false;
    } else if (apiName == "Basecamp") {
      if (integrationSettings && integrationSettings.basecamp && integrationSettings.basecamp.projectData == true || integrationSettings && integrationSettings.basecamp && integrationSettings.basecamp.projectTaskData == true) {
        return true;
      }
      return false;
    } else if (apiName == "Monday.com") {
      if (integrationSettings && integrationSettings.monDay && integrationSettings.monDay.projectData == true || integrationSettings && integrationSettings.monDay && integrationSettings.monDay.projectTaskData == true) {
        return true;
      }
      return false;
    } else if (apiName == "Teamwork") {
      if (integrationSettings && integrationSettings.teamWork && integrationSettings.teamWork.projectData == true || integrationSettings && integrationSettings.teamWork && integrationSettings.teamWork.projectTaskData == true) {
        return true;
      }
      return false;
    }
  }
  function removeLocalStorage(key) {
    var _localStorage, _localStorage$removeI;
    (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : (_localStorage$removeI = _localStorage.removeItem) === null || _localStorage$removeI === void 0 ? void 0 : _localStorage$removeI.call(_localStorage, key);
  }
  function setLocalStorageForName(apiName) {
    var _localStorage2, _localStorage2$setIte;
    (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : (_localStorage2$setIte = _localStorage2.setItem) === null || _localStorage2$setIte === void 0 ? void 0 : _localStorage2$setIte.call(_localStorage2, "apiName", apiName);
  }
  function setLocalStorageData(code) {
    var _localStorage3, _localStorage3$setIte;
    (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : (_localStorage3$setIte = _localStorage3.setItem) === null || _localStorage3$setIte === void 0 ? void 0 : _localStorage3$setIte.call(_localStorage3, "code", code);
  }
  function getLocalStorageData(value) {
    var _localStorage4, _localStorage4$getIte;
    var temp = (_localStorage4 = localStorage) === null || _localStorage4 === void 0 ? void 0 : (_localStorage4$getIte = _localStorage4.getItem) === null || _localStorage4$getIte === void 0 ? void 0 : _localStorage4$getIte.call(_localStorage4, value);
    return temp;
  }
  function authorizeIntegrationApp(apiName) {
    if (apiName == "Asana") {
      getAsanaToken();
    } else if (apiName == "Zoho") {
      connectZohoOAuth();
    } else if (apiName == "Basecamp") {
      // setLocalStorageData(apiName);
      // window.open(
      //   "https://launchpad.37signals.com/authorization/new?type=web_server&client_id=26083f86f6ba0cd805984e88b5257670d8a95429&redirect_uri=http://localhost:3000/integrations",
      //   "_self"
      // );
    } else if (apiName == "Monday.com") {} else if (apiName == "Teamwork") {}
  }
  var disconnectIntegration = React.useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(apiName) {
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            variables = {
              organisationId: organisationId,
              apiName: apiName.toLowerCase()
            };
            _context5.prev = 1;
            _context5.next = 4;
            return disconnectIntegrationDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_INTEGRATION_DETAILS_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 4:
            response = _context5.sent;
            if (!response || !response.data || response.data.disconnectIntegrationDetails == null) {
              toast.error("Error occured, try again");
            } else {
              toast.success("".concat(apiName, " disconnected"));
            }
            _context5.next = 11;
            break;
          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](1);
            toast.error("Error occured, try again");
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 8]]);
    }));
    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }(), [disconnectIntegrationDetails, disconnectIntegrationLoading]);
  if (integrationLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (integrationError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!integrationData) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "workfolio-integration-content-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "workfolio-integration-content-root-card"
  }, integrationData === null || integrationData === void 0 ? void 0 : integrationData.getIntegrationDetails.map(function (integrationValue, key) {
    var icon = integrationValue.icon,
      apiName = integrationValue.apiName,
      isIntegrated = integrationValue.isIntegrated;
    return !isIntegrated ? /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-asana workfolio-integration-content-root-card-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-integration-type"
    }, /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-asana-name workfolio-integration-content-root-card-integration-icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: icon
    }))), /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-integration-submit-root"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline-primary",
      className: "workfolio-integration-content-root-card-integration-connect-button",
      type: "submit",
      disabled: adding && apiName == "asana" || apiName == "zoho" && zohoTokenLoading,
      onClick: function onClick() {
        return authorizeIntegrationApp(apiName);
      }
    }, adding && apiName == "asana" || apiName == "zoho" && zohoTokenLoading ? "Loading..." : "Connect"))) : /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-asana workfolio-integration-content-root-card-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-integration-type"
    }, /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-asana-name workfolio-integration-content-root-card-integration-icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: icon
    })), " ", /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-integration-disconnect",
      onClick: function onClick() {
        return disconnectIntegration(apiName);
      }
    }, "disconnect")), /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-integration-submit-root workfolio-integration-content-root-card-integration-submit-connected"
    }, /*#__PURE__*/React.createElement("div", {
      className: "workfolio-integration-content-root-card-integration-checkbox"
    }, /*#__PURE__*/React.createElement(Form.Check, {
      type: "radio",
      id: "".concat(apiName, "-project-import"),
      label: "Import Projects",
      className: "workfolio-integration-content-root-card-integration-checkbox-input",
      checked: checkProjectManagementIntegration(apiName),
      onChange: function onChange(e) {
        changeProjectManagementIntegration(apiName, e);
      }
    }), /*#__PURE__*/React.createElement(Form.Check, {
      type: "radio",
      id: "".concat(apiName, "-project-import-and-task"),
      label: "Import Projects & Tasks",
      className: "workfolio-integration-content-root-card-integration-checkbox-input",
      checked: checkProjectManagementAndTaskIntegration(apiName),
      onChange: function onChange(e) {
        changeProjectManagementAndTaskIntegration(apiName, e);
      }
    }), displaySaveButton(apiName) ? /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      className: "workfolio-integration-content-root-card-integration-save-button",
      type: "submit",
      onClick: function onClick() {
        return checkProjectManagementIntegration(apiName) ? authorizeProjects(apiName) : checkProjectManagementAndTaskIntegration(apiName) ? authorizeProjectsAndTasks(apiName) : null;
      },
      disabled: importProjectLoading || importProjectAndTaskLoading
    }, importProjectLoading || importProjectAndTaskLoading ? "Loading..." : "Save") : null)));
  }))));
};
export default Integrations;